const MONTH_OPTIONS = Array.from({ length: 12 }, (_, index) => index + 1);
const QUARTER_OPTIONS = [3, 6, 9, 12];

function formatCurrency(value) {
  return `${Number(value || 0).toLocaleString("pt-MZ")} MZN`;
}

export default function PaymentMonthsSelector({
  meses,
  onChange,
  total,
  diasPorMes = 31,
  options = MONTH_OPTIONS,
}) {
  const mesesNumber = Number(meses || 1);
  const dias = mesesNumber * diasPorMes;

  return (
    <div className="mb-4 rounded-md border border-blue-100 bg-blue-50 p-3 text-sm text-slate-700">
      <label className="mb-2 block font-semibold text-slate-800">
        Meses a pagar
      </label>
      <select
        value={mesesNumber}
        onChange={(event) => onChange(Number(event.target.value))}
        className="w-full rounded-md border border-blue-200 bg-white px-3 py-2 outline-none focus:border-blue-500"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option === 1 ? "1 mes" : `${option} meses`}
          </option>
        ))}
      </select>

      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        <div className="rounded-md bg-white px-3 py-2">
          <p className="text-xs text-slate-500">Validade comprada</p>
          <p className="font-semibold text-slate-900">{dias} dias</p>
        </div>
        <div className="rounded-md bg-white px-3 py-2">
          <p className="text-xs text-slate-500">Total a pagar</p>
          <p className="font-semibold text-slate-900">{formatCurrency(total)}</p>
        </div>
      </div>
    </div>
  );
}

export { MONTH_OPTIONS, QUARTER_OPTIONS };
